// Persisted flag: has this user ever seen a successful first PowerSync sync
// on this device? Consumed by AppBootGate (Variant 2 splash) to decide
// whether to block first render on initial sync. On subsequent reloads the
// flag is set → SQLite already has data → splash never renders, local-first
// feel preserved.
//
// One flag per userId so sign-in-as-different-user on a shared device still
// sees the splash for that user's first sync.

const PREFIX = 'imki:synced:'

export function hasEverSynced(userId: string | null | undefined): boolean {
  if (!userId || typeof localStorage === 'undefined') return false
  try {
    return localStorage.getItem(PREFIX + userId) === '1'
  } catch {
    return false
  }
}

export function markEverSynced(userId: string | null | undefined): void {
  if (!userId || typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(PREFIX + userId, '1')
  } catch { /* quota or private mode — no-op, splash just shows again next time */ }
}
